import React from 'react'
import { Link } from 'react-router-dom'
const SubTitle = ({titles}) => {
  return (
    <div className='d-flex justify-content-start mt-5 me-3 mb-5 '>
      <Link to='/'>
      <i  class="fa-solid fa-house sup-title-link" style={{ fontSize:'16px',marginTop:'7px' }}></i>
      </Link>
       {titles.map((title,idx)=>(
        <div key={idx}  className=' d-flex' >
        <span className='me-1 ms-1 mt-1'>/</span>
        {title.link?(
          <Link to={title.link} style={{ textDecoration:'none' }}>
                  <h3 className='sup-title-link'  >{title.name}</h3>
          </Link>
        ):(
          <h3 style={{ color:'#18181899',fontSize:'13px',marginTop:'7px' }}>{title.name}</h3>
        )}
        </div>
       ))}
      

    </div>
  )
}

export default SubTitle
